<template>
  <f7-page class="main-time-dimension-comparator">
    <div class="time-card">
      <!-- Submenú en la parte superior del card -->
      <div class="sub-menu-wrapper">
        <SubMenu
          :items="MenuOptions.contexts.samples.itemsByArea.agronomy"
        />
      </div>
      <!-- Aquí tu título principal -->
      <div class="summary-sidebar-header">
        <span class="summary-title-text">
          {{ farmStr }} > {{ $t('comparative') }}
        </span>
      </div>
      <div v-if="loadedGIS">
        <!-- Two Gis -->
        <div class="content-comparation">
          <!-- Item Map -->
          <div class="card map-card">
            <!-- <div class="card-header color-primary">
              <div>{{ leftParcel.name }}</div>
            </div> -->
            <div class="card-content padding">
              <div class="floating-sector-title">
                <div class="floating-sector-bg"></div>
                <div class="floating-sector-label">
                  {{ leftParcel.name }}
                </div>
              </div>
              <WMSMap
                :zoom="zoom"
                :name-map="`${mainMap}Left`"
                :layer="layerLeft"
                :index="currentIndexes[`${mainMap}Left`]"
                :height="'450px'"
                :center="leftParcel.coordinates"
              />
            </div>
            <div class="card-footer justify-content-center">
              <DatePicker
                :key-id="`${mainMap}Left`"
                :default-index="'NDVI'"
                :dates-list="datesListLeft"
              />
            </div>
          </div>
          <!-- Item Map -->
          <div class="card map-card">
            <!-- <div class="card-header color-primary">
              <div>{{ rightParcel.name }}</div>
            </div> -->
            <div class="card-content padding">
              <div class="floating-sector-title">
                <div class="floating-sector-bg"></div>
                <div class="floating-sector-label">
                  {{ rightParcel.name }}
                </div>
              </div>

              <WMSMap
                :zoom="zoom"
                :name-map="`${mainMap}Right`"
                :layer="layerRight"
                :index="currentIndexes[`${mainMap}Right`]"
                :height="'450px'"
                :center="rightParcel.coordinates"
              />
            </div>
            <div class="card-footer justify-content-center">
              <DatePicker
                :key-id="`${mainMap}Right`"
                :default-index="'NDVI'"
                :dates-list="datesListRight"
              />
            </div>
          </div>
        </div>
        <!-- /. Two Gis -->

        <div class="card">
          <div
            class="card-header color-primary display-flex justify-content-space-between align-items-center"
          >
            <div>{{ $t('temporalLine') }}</div>
            <div>
              <f7-input
                type="datepicker"
                class="recepDate"
                :placeholder="$t('agronomySample.chooseDates')"
                :clear-button="true"
                :close-on-select="true"
                :calendar-params="{
                  value: [
                    timeLineIndexInitDate,
                    timeLineIndexEndDate,
                  ],
                  closeOnSelect: true,
                  rangePicker: true,
                  dateFormat: {
                    month: 'numeric',
                    day: 'numeric',
                    year: 'numeric',
                  },
                }"
                @calendar:change="calendarChange"
              />
            </div>
          </div>
          <div class="card-content padding-half">
            <TimelineGraphWMS
              :timeline-indexes="timeLineIndexesWMS"
              :index="selectedIndex"
            />
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import Api from '@/services/Api';
import { mapActions, mapState } from 'vuex';
import WMSMap from '@/components/Gis/WMSMap/index.vue';
import DatePicker from '@/components/Gis/WMSMap/datePicker/index.vue';
import moment from 'moment';
import TimelineGraphWMS from '@/components/Gis/WMSMap/timeLineGraph/index.vue';
import MenuOptions from '@/json/menuOptions.json';
import SubMenu from '@/components/SubMenu/index.vue';

export default {
  components: {
    WMSMap,
    DatePicker,
    TimelineGraphWMS,
    SubMenu,
  },
  data() {
    return {
      loadedGIS: false,
      loadedTimeLine: false,
      zoom: 17,
      mainMap: 'gis',
      datesListLeft: {},
      datesListRight: {},
      layerLeft: {
        name: 'gis',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerBesafer(),
        options: {
          layers: '',
          outputFormat: 'image/png',
          transparent: true,
          styles: 'NDVI',
        },
      },
      layerRight: {
        name: 'gis',
        visible: false,
        timeDimension: true,
        baseUrl: Api.getGeoServerBesafer(),
        options: {
          layers: '',
          outputFormat: 'image/png',
          transparent: true,
          styles: 'NDVI',
        },
      },
      MenuOptions,
    };
  },
  computed: {
    ...mapState('gisComparator', [
      'leftComparator',
      'rightComparator',
      'leftParcel',
      'rightParcel',
      'timeLineIndexInitDate',
      'timeLineIndexEndDate',
    ]),
    ...mapState('gis', [
      'datesList',
      'currentIndexes',
      'timeLineIndexesWMS',
      'selectedIndex',
    ]),
    ...mapState('registerFarm', ['farmStr']),
  },
  beforeMount() {
    this.replaceCurrent({
      name: this.$t('comparative'),
      disabled: false,
      page: 'GisComparatorPage',
      active: true,
    });
  },
  async mounted() {
    this.$f7.preloader.show();
    this.setDates();
    try {
      this.loadedGIS = false;
      this.layerLeft.options.layers = Api.normalizeGISLayerId(
        this.leftParcel.gisId || this.leftComparator
      );
      this.layerRight.options.layers = Api.normalizeGISLayerId(
        this.rightParcel.gisId || this.rightComparator
      );
      await this.fetchDatesLayer(this.layerLeft.options.layers);
      this.datesListLeft = this.datesList;
      await this.fetchDatesLayer(this.layerRight.options.layers);
      this.datesListRight = this.datesList;
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.$f7.preloader.hide();
      this.loadedGIS = true;
    }
  },
  methods: {
    setDates() {
      const today = new Date();
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

      this.setTimeLineIndexInitDate(threeMonthsAgo);
      this.setTimeLineIndexEndDate(today);
    },
    async calendarChange(e) {
      if (e.length === 2) {
        this.setTimeLineIndexInitDate(e[0]);
        this.setTimeLineIndexEndDate(e[1]);

        this.requestNewData();
      } else if (e.length === 0) {
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        this.setTimeLineIndexInitDate(threeMonthsAgo);
        this.setTimeLineIndexEndDate(today);

        this.requestNewData();
      }
    },
    async requestNewData() {
      this.loadedTimeLine = false;
      const timeLineIndexLeft = await this.fetchTimelineIndexesWMS({
        location: this.leftComparator,
        initDate: moment(this.timeLineIndexInitDate).format(
          'YYYY-MM-DD'
        ),
        endDate: moment(this.timeLineIndexEndDate).format(
          'YYYY-MM-DD'
        ),
        index: this.selectedIndex,
      });

      const leftIndexesFormatted = timeLineIndexLeft.map((el) => {
        return {
          ...el,
          values: el.values.map((value) => {
            return {
              index: value.index,
              count: value.count,
              [`${this.leftParcel.id} max`]: value.max,
              [`${this.leftParcel.id} mean`]: value.mean,
              [`${this.leftParcel.id} min`]: value.min,
              [`${this.leftParcel.id} stddev`]: value.stddev,
            };
          }),
        };
      });

      const timeLineIndexRight = await this.fetchTimelineIndexesWMS({
        location: this.rightComparator,
        initDate: moment(this.timeLineIndexInitDate).format(
          'YYYY-MM-DD'
        ),
        endDate: moment(this.timeLineIndexEndDate).format(
          'YYYY-MM-DD'
        ),
        index: this.selectedIndex,
      });

      const rightIndexesFormatted = timeLineIndexRight.map((el) => {
        return {
          ...el,
          values: el.values.map((value) => {
            return {
              index: value.index,
              count: value.count,
              [`${this.rightParcel.id} max`]: value.max,
              [`${this.rightParcel.id} mean`]: value.mean,
              [`${this.rightParcel.id} min`]: value.min,
              [`${this.rightParcel.id} stddev`]: value.stddev,
            };
          }),
        };
      });

      const timeLineIndexes = leftIndexesFormatted.concat(
        rightIndexesFormatted
      );

      this.setTimelineIndexesWMS(timeLineIndexes);
      this.loadedTimeLine = true;
    },
    ...mapActions('gis', [
      'setCurrentIndexes',
      'setCurrentInitIntervalDates',
      'setCurrentEndIntervalDates',
      'fetchDatesLayer',
      'fetchTimelineIndexesWMS',
      'setTimelineIndexesWMS',
    ]),
    ...mapActions('gisComparator', [
      'setTimeLineIndexInitDate',
      'setTimeLineIndexEndDate',
    ]),
    ...mapActions('breadcrumb', ['replaceCurrent']),
  },
};
</script>
<style>
.content-comparation {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
}

.input-clear-button {
  position: absolute !important;
  top: 37% !important;
  right: 25px !important;
  transform: translateY(-50%) !important;
  z-index: 2;
  font-size: 14px;
  line-height: 1 !important;
}

.recepDate {
  margin-bottom: 0;
}

.sub-menu-wrapper {
  width: 100%;
}

.summary-sidebar-header {
  font-size: 20px;
  font-weight: bold;
  color: var(--Primary-Blue-60, #00346a);
  margin-top: 15px;
  margin-bottom: 10px;
  padding-left: 10px;
}

.summary-title-text {
  display: inline-block;
}

/* Card blanco flotante (igual estilo que el otro) */
.time-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  margin: 0 24px; /* margen exterior del card (ajústalo si quieres) */
  padding: 10px 28px; /* padding interno del card */
  box-sizing: border-box;
  height: 835px;
}

/* Alinea submenú y título a los laterales del card (sin sangrías extras) */
.time-card .sub-menu-wrapper,
.time-card .summary-sidebar-header {
  margin: 0 0 12px 0 !important;
  padding: 0 !important;
  width: 100%;
}

/* El bloque de contenido respeta el padding del card */
.time-card .content-devx {
  margin: 0 !important;
  width: 100%;
  box-sizing: border-box;
}

.time-card .sub-menu-wrapper,
.time-card .summary-sidebar-header {
  padding-left: 10px !important;
}

/* Mantiene la estructura del card */
.map-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  overflow: hidden; /* evita que el mapa se salga */
}

/* El contenedor del mapa ahora tiene padding lateral mínimo */
.map-card .card-content {
  position: relative;
  padding: 6px; /* margen interno para dejar el borde blanco visible */
  box-sizing: border-box;
}

/* El mapa ocupa todo el espacio dentro del área visible */
.map-card .card-content > *:not(.floating-sector-title) {
  border-radius: 6px;
  overflow: hidden;
}

/* 🟦 Título flotante tipo NDVI */
/* Card de mapa con borde blanco homogéneo */
.map-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}
.map-card .card-content {
  position: relative;
  padding: 6px; /* marco blanco */
  box-sizing: border-box;
}
.map-card .card-content > *:not(.floating-sector-title) {
  border-radius: 6px;
  overflow: hidden;
}

/* ===== Etiqueta flotante estilo NDVI ===== */
.floating-sector-title {
  position: absolute;
  top: 40px;
  left: 100px;
  z-index: 1100;
  pointer-events: none;
}

/* Fondo translúcido con más margen alrededor */
.floating-sector-bg {
  position: absolute;
  inset: -12px; /* antes -6px, ahora más amplio */
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25);
  border: 2px solid rgba(0, 0, 0, 0.2);
}

/* Píldora blanca encima */
.floating-sector-label {
  position: relative;
  background: #fff;
  color: #000;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}
</style>
